import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { homedesignerhighlightList, products_list } from '../services/Product-service';
import Loader from './Loader';

const PRODUCT_SLOTS = 6;

function isValidProduct(item) {
    return item?.id && (item.product_thumbail || item.cover_image);
}

function Wendell({ showhiighlightd, sectionTitle }) {
    const [products, setProducts] = useState([]);
    const [designer, setDesigner] = useState(null);
    const [apiTitle, setApiTitle] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!showhiighlightd) return;

        setLoading(true);
        homedesignerhighlightList()
            .then(async (data) => {
                const list = Array.isArray(data?.data) ? data.data : [];
                const rawDesigner = data?.designer;
                const nextDesigner = Array.isArray(rawDesigner)
                    ? (rawDesigner[0] || null)
                    : (rawDesigner || null);

                let nextProducts = list.filter(isValidProduct).slice(0, PRODUCT_SLOTS);

                // Fill remaining grid slots with default newest products.
                if (nextProducts.length < PRODUCT_SLOTS) {
                    try {
                        const fallback = await products_list({
                            offset: 0,
                            limit: PRODUCT_SLOTS,
                            sort_by: 'newest',
                        });
                        const existingIds = new Set(nextProducts.map((item) => item.id));
                        const fill = (fallback?.products || [])
                            .filter(isValidProduct)
                            .filter((item) => !existingIds.has(item.id))
                            .slice(0, PRODUCT_SLOTS - nextProducts.length);
                        nextProducts = [...nextProducts, ...fill];
                    } catch (fallbackError) {
                        console.error('Error fetching default products for highlight designer:', fallbackError);
                    }
                }

                setDesigner(nextDesigner);
                setProducts(nextProducts);
                setApiTitle(data?.section_ttile || data?.section_title || '');
            })
            .catch((error) => {
                console.error('Error fetching highlight designer:', error);
                setDesigner(null);
                setProducts([]);
                setApiTitle('');
            })
            .finally(() => setLoading(false));
    }, [showhiighlightd]);

    if (!showhiighlightd) return null;
    if (loading) return <Loader />;

    const designerImage = designer?.designer_cover || designer?.designer_thumbnail;
    const designerLink = designer?.id
        ? `/category/?designer_id=${designer.id}`
        : '/category';
    const showFeature = !!(designerImage);
    const showProducts = products.length > 0;

    if (!showFeature && !showProducts) return null;

    return (
        <div className="App">
            <div className="BreakPointContainer">
                <div className="CarouselSectionContainer design-spotlight">
                    <div className={`design-spotlight-layout${!showFeature || !showProducts ? ' is-single' : ''}`}>
                        {showFeature && (
                            <div className="design-spotlight-feature">
                                <div className="SectionTitle">
                                    <h1 className="m-t-0 m-b-15 text-left demi-bold">
                                        {apiTitle || sectionTitle || 'HIGHLIGHT DESIGNER'}
                                    </h1>
                                </div>
                                <Link to={designerLink} className="design-spotlight-feature-link">
                                    <img
                                        src={designerImage}
                                        alt={designer?.designer_name || 'Highlight designer'}
                                    />
                                    <span className="design-spotlight-overlay">
                                        <span className="design-spotlight-overlay-name demi-bold">
                                            {designer?.designer_name}
                                        </span>
                                        <span className="design-spotlight-shop">SHOP NOW</span>
                                    </span>
                                </Link>
                            </div>
                        )}
                        {showProducts && (
                            <div className="design-spotlight-collections">
                                <div className="SectionTitle">
                                    <h1 className="m-t-0 m-b-15 text-left demi-bold">
                                        {designer?.designer_name || 'FEATURED PRODUCTS'}
                                    </h1>
                                </div>
                                <div className="design-spotlight-grid">
                                    {products.map((product) => (
                                        <Link
                                            to={`/products/productdetails/${product.id}`}
                                            className="design-spotlight-card"
                                            key={product.id}
                                        >
                                            <div className="design-spotlight-card-media">
                                                <img
                                                    src={product.product_thumbail || product.cover_image}
                                                    alt={product.product_title || ''}
                                                />
                                            </div>
                                            <div className="h5 demi-bold design-spotlight-name">
                                                {product.product_title}
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Wendell;
